<app-breadcrumb [title]="'customer license' | translate" [items]="['security' | translate]" [active_item]="'customer license' | translate"></app-breadcrumb>
<style>
  .custom-card-erp{
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 800px) {
    .desktop-hidden {
      display: initial;
    }
    .mobile-hidden {
      display: none;
    }
  }
  @media screen and (min-width: 800px) {
    .desktop-hidden {
      display: none;
    }
    .mobile-hidden {
      display: initial;
    }
  }

</style>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">

      <div class="custom-card-erp" *ngIf="'Read' | hasPermission: userPermissions">
        <div style="float:left;">
          <input
                  type="text"
                  style="padding:5px;margin:5px auto;width:30%;"
                  placeholder="{{ 'type to filter the'|translate }} {{ 'name'|translate }} ..."
                  (keyup)="updateFilter($event)"
          />

        </div>


          <ngx-datatable
                  style="width: 100%"
                  class="material striped"
                  selectionType="checkbox"
                  [rows]="rows"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [limit]="100"
                  rowHeight="auto"
                  columnMode="force"
                  [scrollbarH]="true"
                  [loadingIndicator]="loadingIndicator"
                  [reorderable]="reorderable"
                  [selected]="selected"
                  (activate)="onActivate($event)"
                  (select)="onSelect($event)"
                  [selectAllRowsOnPage]="false"
                  [displayCheck]="displayCheck"
          >
            <ngx-datatable-column
                    [width]="55"
                    [sortable]="false"
                    [canAutoResize]="false"
                    [draggable]="false"
                    [resizeable]="false"
                    [headerCheckboxable]="true"
                    [checkboxable]="true"
            >

            </ngx-datatable-column>

            <ngx-datatable-column name="licenseKey">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span class="f-w-700 sp-policy-erp">{{ 'license Key'|translate }}</span>
              </ng-template>
            </ngx-datatable-column>

              <ngx-datatable-column name="startAt">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{ 'start date'|translate }}</span>
                  </ng-template>
                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      {{row.startAt | date}}
                  </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="endAt">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{ 'end date'|translate }}</span>
                  </ng-template>
                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      {{row.endAt | date}}
                  </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="isEnable">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{ 'status'|translate }}</span>
                  </ng-template>

                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <ng-container *ngIf="row.isUsed == 1; else otherFormat">
                          <span class="badge rounded-pill badge-light-success" style="font-size: 13px">{{ 'active' | translate }}</span>
                      </ng-container>
                      <ng-template #otherFormat>
                          <span class="badge rounded-pill badge-light-danger" style="font-size: 13px">{{ 'inactive' | translate }}</span>
                      </ng-template>
                  </ng-template>
              </ngx-datatable-column>

          </ngx-datatable>
      </div>
    </div>
    </div>
  </div>
